import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './adminLinksInitialState';
import {
  _setAdminLists,
  _setViewUnviewUsers,
  _setViewEngagementLists,
  _setViewEngagementLinkId,
} from './adminLinksAction';

const adminLinksSlice = createSlice({
  name: 'delta/adminLinks',
  initialState: initialState,
  reducers: {
    setAdminLists: _setAdminLists,
    resetAdminLists: () => initialState,
    setViewUnviewUsers: _setViewUnviewUsers,
    setViewEngagementLists: _setViewEngagementLists,
    setViewEngagementLinkId: _setViewEngagementLinkId,
  },
});

export const {
  setAdminLists,
  resetAdminLists,
  setViewUnviewUsers,
  setViewEngagementLists,
  setViewEngagementLinkId,
} = adminLinksSlice.actions;

export default adminLinksSlice.reducer;
